import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { homePathFor } from "@/lib/roles";
import LoadingScreen from "@/components/LoadingScreen";
import Welcome from "@/pages/Welcome";
import NoAccess from "@/pages/NoAccess";

export default function Hub() {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user) return <Welcome />;
  const path = homePathFor(user);
  if (!path) return <NoAccess />;
  return <Navigate to={path} replace />;
}
